import {ReactNode} from 'react';
import {DayOfWeekList} from '../../../graphql/generated/types';
import {DayOfWeekListContainer} from '../container/DayOfWeekListContainer';
import {DayOfWeekCommonProps, DayOfWeekReferenceKeyListProps} from '../type';
import {DayOfWeekColumnList} from './DayOfWeekColumnList';
import {DayOfWeekColumnTitle} from './DayOfWeekColumnTitle';

interface Props extends DayOfWeekCommonProps, DayOfWeekReferenceKeyListProps {
  children: (data: DayOfWeekList, referenceKeyIndex: number) => ReactNode;
}

export const DayOfWeekColumn = ({
  referenceKeyList,
  children,
  ...rest
}: Props) => {
  return (
    <>
      {referenceKeyList.map((referenceKey, referenceKeyIndex) => (
        <DayOfWeekListContainer
          key={referenceKey}
          referenceKey={referenceKey}
          {...rest}
        >
          {data => children(data, referenceKeyIndex)}
        </DayOfWeekListContainer>
      ))}
    </>
  );
};

DayOfWeekColumn.List = DayOfWeekColumnList;
DayOfWeekColumn.Title = DayOfWeekColumnTitle;
